export default __webpack_public_path__ + "static/media/harriete.550f6025.png";